import { useEffect, useState, ChangeEvent } from 'react'
import { useNavigate } from 'react-router-dom'
import {
  getDashboardDataClient,
  getDashboardDataProduct,
  getDashboardResume,
} from '../../services/DashboardSevice/getDashboardData'
import { dateHelper } from '../../utils/dateHelper'

export const useDashboard = () => {
  const navigate = useNavigate()
  const goToPageProducts = (id: number) => {
    navigate(`/dashboard/produto/${id}`)
  }
  // A origem vai na rota, igual ao goToPageProducts logo acima: e ela que faz o menu lateral
  // marcar Dashboard e o botao voltar da ficha do cliente devolver para o Dashboard.
  const goToPageClient = (id: number) => {
    navigate(`/dashboard/cliente/${id}`)
  }

  const [product, setProduct] = useState<TableDashboard>({} as TableDashboard)
  const [client, setClient] = useState<TableDashboard>({} as TableDashboard)
  const [dashboardResume, setDashboardResume] =
    useState<GetDashboardResumeType>()
  const [isOnHighProducts, setIsOnHighProducts] = useState(true)
  const [isOnHighClients, setIsOnHighClients] = useState(true)
  const [date, setDate] = useState(dateHelper.thisMonth())
  const [isLoading, setIsLoading] = useState(true)
  const [isLoadingProducts, setIsLoadingProducts] = useState(true)
  const [isLoadingClients, setIsLoadingClients] = useState(true)
  const [currentPagePruduct, setCurrentPageProduct] = useState(1)
  const [currentPageClient, setCurrentPageClient] = useState(1)

  const selectPeriod = (event: ChangeEvent<HTMLSelectElement>) => {
    const { value } = event.currentTarget
    if (value === '0') {
      setDate(dateHelper.thisMonth())
    } else {
      setDate(dateHelper.lastDays(Number(value)))
    }
  }

  const changeStateProducts = () => setIsOnHighProducts(!isOnHighProducts)
  const changeStateClients = () => setIsOnHighClients(!isOnHighClients)
  const handleDashboardDataProducts = async (
    callback: (result: TableDashboard) => void,
    dataType: DataType,
    dateStart: string,
    dateEnd: string
  ) => {
    setIsLoadingProducts(true)
    const result = await getDashboardDataProduct(
      isOnHighProducts ? 'EM_ALTA' : 'EM_BAIXA',
      dataType,
      dateStart,
      dateEnd,
      currentPagePruduct
    )
    const goToPage = (url: string) => {
      navigate(url)
    }
    setIsLoadingProducts(false)
    if ('message' in result) {
      goToPage('/dashboard')
    } else {
      callback(result)
    }
  }
  const handleDashboardDataClient = async (
    callback: (result: TableDashboard) => void,
    dataType: DataType,
    dateStart: string,
    dateEnd: string
  ) => {
    setIsLoadingClients(true)
    const result = await getDashboardDataClient(
      isOnHighClients ? 'EM_ALTA' : 'EM_BAIXA',
      dataType,
      dateStart,
      dateEnd,
      currentPageClient
    )
    const goToPage = (url: string) => {
      navigate(url)
    }
    setIsLoadingClients(false)
    if ('message' in result) {
      goToPage('/dashboard')
    } else {
      callback(result)
    }
  }

  const goToPage = (url: string) => {
    navigate(url)
  }
  const handleDashboardResume = async () => {
    setIsLoading(true)
    const result = await getDashboardResume(date.start, date.end)
    setIsLoading(false)
    if ('message' in result) {
      goToPage('/dashboard')
    } else {
      setDashboardResume(result)
    }
  }

  useEffect(() => {
    handleDashboardDataClient(setClient, 'clientes', date.start, date.end)
  }, [isOnHighClients, date, currentPageClient])

  useEffect(() => {
    handleDashboardDataProducts(setProduct, 'produtos', date.start, date.end)
  }, [isOnHighProducts, date, currentPagePruduct])

  useEffect(() => {
    handleDashboardResume()
  }, [date])

  return {
    product,
    client,
    dashboardResume,
    isLoading,
    isOnHighProducts,
    isOnHighClients,
    isLoadingProducts,
    isLoadingClients,
    goToPageProducts,
    goToPageClient,
    changeStateClients,
    changeStateProducts,
    selectPeriod,
    setIsLoading,
    currentPagePruduct,
    setCurrentPageProduct,
    currentPageClient,
    setCurrentPageClient,
  }
}
